// TODO: should be marked as server-only
// import 'server-only';
import { Locale } from '@headless-workspace/config';
import { Result } from '@headless-workspace/core-domain';
import { EcomConfigKeys } from './EcomConfigKeys';
import { getCachedEcomConfigs } from './getCachedEcomConfigs';

export const getCachedEcomConfigByKey = async <T>(locale: Locale, key: EcomConfigKeys) => {
    const ecomConfigs = await getCachedEcomConfigs(locale);
    return ecomConfigs[key] as Result<T>;
};
